export const sleveesList  = [
    {
        text: "K55",
        color: "#8b572a"
    },
    {
        text : "72/62",
        color: "#f8e71c"
    },
    {
        text : "92/80",
        color: "#bd10e0"
    },
    {
        text : "112/100",
        color : "#50e3c2"
    },
    {
        text : "132/120",
        color : "#d0021b"
    },
    {
        text : "163/148",
        color : "#7ed321"
    },
    {
        text : "214/195",
        color : "#000000"
    }
];


// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/OptionsArea/sleveesList.js